import React from "react";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";
import TextSlider from "./TextSlider.jsx";

const Header = () => {
  return (
    <header className="container-fluid px-3 pt-2 pt-md-4 overflow-hidden">
      {/* SEO Etiketleri */}
      <Helmet>
        <title>Gülfem Dikici Çelikay | Klinik Psikolog (MSc)</title>
        <meta
          name="description"
          content="Klinik Psikolog Gülfem Dikici Çelikay ile bireysel terapi, danışmanlık ve psikolojik destek hizmetleri. Online randevu alın."
        />
      </Helmet>

      {/* Başlık Bölümü */}
      <div className="text-center mb-5">
        {/* Başlık: Mobilde daha küçük (fs-3), masaüstünde büyük (fs-1) */}
        <h1 className="fw-bold fs-3 fs-md-1 mb-1">
          GÜLFEM DİKİCİ ÇELİKAY
        </h1>
        <h2 className="fw-semibold fs-6 fs-md-4">
          KLİNİK PSİKOLOG (MSc)
        </h2>
      </div>

      {/* Menü: Mobilde dikey, tablette yan yana */}
      <nav className="d-flex flex-column flex-md-row justify-content-center align-items-center mt-5 mb-2 gap-2 gap-md-5">
        <Link to="/about">
          <button type="button" className="btn btn-link text-decoration-none fw-semibold text-black p-2">Hakkımda</button>
          </Link>

          <Link to="/programs">
          <button type="button" className="btn btn-link text-decoration-none fw-semibold text-black p-2">Çalışma Alanlarım</button>
          </Link>

          <button type="button" className="btn btn-link text-decoration-none fw-semibold text-black p-2">Blog</button>

          <Link to="/contact">
          <button type="button" className="btn btn-link text-decoration-none fw-semibold text-black p-2">İletişim</button>
          </Link>
      </nav>

      {/* Turuncu Çizgi: Taşmayı önlemek için width %100 yapıldı */}
      <div className="d-flex justify-content-center w-100">
        <hr
          style={{
            height: "2px",
            backgroundColor: "#cc5500",
            border: "none",
            opacity: 0.6,
            width: "100%",
            maxWidth: "1600px",
            boxShadow: "0px 4px 8px rgba(76, 32, 0, 0.4)", 
            margin: "0 0"
          }}
        />
      </div>

      <div className="text-center px-1">
        <div className="fs-6 fs-md-5 fw-bold fst-italic mx-auto" style={{ maxWidth: "800px", marginTop: "120px" }}>
          <TextSlider>
          </TextSlider>
        </div>
      </div>
    </header>
  );
};

export default Header;